/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize RolesCreation View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './rolesViewEdit';

export const mapStateToPropsRoleViewEdit = mapStateToProps;
export const mapDispatchToPropsRoleViewEdit = mapDispatchToProps;

export default connect(
  mapStateToPropsRoleViewEdit,
  mapDispatchToPropsRoleViewEdit
)(View);
